import React, { useState } from 'react';
import { PaymentResultScreen } from './PaymentResultScreen';
import { PayRentTypes } from '../../PayRentTypes';
import { navigate } from 'gatsby';
import { PayRentForm } from '../PayRent/PayRentForm';
import { PayRentPaymentErrorScreen } from '../ErrorScreens/PaymentErrorScreen';
import { Spinner } from '../../../../components/spinner';
import { Column } from '@codeparva/ui-components-library';
import { checkForSurchargeOrDiscount } from '../../../rentalPage/helpers/paymentComponentHelper';
import {
  enableAutoPayForTenant,
  makePayment,
} from '@codeparva/v11-tfw-api-library';

export const PayRent = ({
  billAheadResponse,
  searchResponse,
  next_Billing_Date,
  public_key,
  payment_method,
  card_processor,
  ledger_id,
  facilityId,
  tenantToken,
  unitSearchApiResponse,
  tenantWebsitesConfigInfo,
}: PayRentTypes.TPayRentComponent) => {
  const [switchScreen, setSwitchScreen] = useState(0);
  const [isloading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [paymentScreenData, setPaymentScreenData] = useState<
    PayRentTypes.TPaymentResultScreen
  >();
  const allLedgers = searchResponse.map(({ ledger }: any) => ledger);
  const eSignPendingUnitsArray = unitSearchApiResponse
    .filter(
      (indivUnitData: any) => indivUnitData.rental_status === 'Esign_Pending'
    )
    .map((unitsArray: any) => unitsArray.label);
  let ledgers: any = [];
  for (let i = 0; i < allLedgers.length; i++) {
    for (let j = 0; j < allLedgers[i].length; j++) {
      ledgers.push([allLedgers[i][j]][0]);
    }
  }
  const selectedLedgerInfo: any = ledgers.filter(
    (indivLedger: any) => indivLedger.id === ledger_id
  )[0];
  const { email } = searchResponse[0];

  const {
    balance,
    id: LedgerId,
    financials: {
      card_info = {},
      preferred_payment_method_id = '',
      is_auto_pay_enabled = false,
    } = {},
  } = selectedLedgerInfo;
  const { billing_info, masked_card_number } = card_info ?? {};
  const { address, name } = billing_info ?? {};
  const cardProcessorIds = card_processor;
  const currPage = location.pathname.substring(
    0,
    location.pathname.lastIndexOf('/')
  );
  const billingDetailsConfig = {
    current_balance_due: balance,
    estimated_new_charges: billAheadResponse,
    next_billing_data: next_Billing_Date,
  };
  const constantsRequestBody = {
    ledger_id: LedgerId,
    receipt_delivery_method: 'Email',
  };
  const showErrorScreen = () => {
    if (hasError) {
      return (
        <PayRentPaymentErrorScreen
          setError={setHasError}
          setLoading={setIsLoading}
        />
      );
    } else {
      return (
        <div className="loaderParent">
          <Spinner />
        </div>
      );
    }
  };
  const callBackHandler: PayRentTypes.TCallBackHandler = async formRequestBody => {
    delete formRequestBody.tenantUserName;
    delete formRequestBody.tenantPassword;
    delete formRequestBody.tenantId;
    delete formRequestBody.tenantIdFromCreationAPI;
    delete formRequestBody.individualUnitData;
    setIsLoading(true);
    const requestBody = {
      ...constantsRequestBody,
      ...formRequestBody,
    };
    if (requestBody.use_card_on_file) {
      delete requestBody.auto_pay_enabled;
    }
    const [
      err,
      { data: { success = false, data: paymentResponse = {} } = {} } = {},
    ] = await makePayment({
      paymentRequest: requestBody,
      facilityId,
      tenantToken,
    });

    if (err) {
      console.error('Error from new card section', err);
      setHasError(true);
      return;
    }

    const {
      ledger_balance,
      message,
      transaction: { approval_number = '' },
      amount_details: { approved_total_amount },
    } = paymentResponse;

    if (
      formRequestBody.use_card_on_file &&
      formRequestBody.auto_pay_enabled === true
    ) {
      const AutoPayEnableRequestBody = {
        payment_method_id: formRequestBody.payment_method_id,
        card_info,
      };
      await enableAutoPayForTenant({
        ledgerId: ledger_id || '',
        facilityId,
        tenantToken,
        autoPayEnableReq: AutoPayEnableRequestBody,
      });
    }

    setPaymentScreenData({
      tenantMail: email,
      authCode: approval_number,
      balanceDue: ledger_balance,
      paidAmount: approved_total_amount,
      errorDetails: message,
      is_successful: success,
      clickHandler: () => navigate(currPage),
    });
    setIsLoading(false);
    setSwitchScreen(1);
    setSwitchScreen(1);
  };

  const isSurchargeOrDiscountAvailable = checkForSurchargeOrDiscount(
    payment_method.data
  );

  const payRentFormProps = {
    billingDetailsConfig,
    callBackHandler,
    payment_method,
    public_key,
    address,
    name,
    card_info,
    preferred_payment_method_id,
    billing_info,
    masked_card_number,
    cardProcessorIds,
    is_auto_pay_enabled,
    isSurchargeOrDiscountAvailable,
    tenantWebsitesConfigInfo,
    facilityId,
    tenantToken,
  };

  const getCurrentComponent = () => {
    switch (switchScreen) {
      case 1:
        return <PaymentResultScreen {...paymentScreenData} />;
      default:
        return <PayRentForm {...payRentFormProps} />;
    }
  };

  const arePendingUnitsPresent =
    eSignPendingUnitsArray.length > 0 && eSignPendingUnitsArray[0];

  const shouldNotAllowPayment = !(balance > 0) && arePendingUnitsPresent;

  const EsignPendingAlertBar = () => {
    return (
      <Column className="statusAlertBar">
        {`ESign is pending for Units: ${eSignPendingUnitsArray.toString()} please complete the e-sign for these units`}
      </Column>
    );
  };

  return (
    <>
      <>{arePendingUnitsPresent ? <EsignPendingAlertBar /> : <></>}</>
      <div className={`${shouldNotAllowPayment ? 'uneditableSection' : ''}`}>
        <div className="overlaySection"></div>
        {isloading ? showErrorScreen() : getCurrentComponent()}
      </div>
    </>
  );
};
